import PropTypes from 'prop-types';
import { SvgIcon } from '@mui/material';

const cubeViewFaces = {
    back: '9 6 17 6 17 14 9 14',
    front: '7 8 15 8 15 16 7 16',
    right: '15 8 18 5 18 13 15 16',
    top: '7 8 10 5 18 5 15 8',
};

function QuickViewCubeIcon({
    className,
    view,
}) {
    const transformedView = view === 'left' ? 'right' : view === 'bottom' ? 'top' : view;
    const transform = view === 'left'
        ? 'translate(24 0) scale(-1 1)'
        : view === 'bottom'
            ? 'translate(0 24) scale(1 -1)'
            : undefined;
    const highlightedFace = transformedView === 'behind' ? cubeViewFaces.back : cubeViewFaces[transformedView];

    return (
        <SvgIcon className={className} viewBox="0 0 24 24" aria-hidden="true">
            {transformedView === 'behind' ? (
                <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.6"
                >
                    <polygon points={highlightedFace} fill="currentColor" fillOpacity="0.22" stroke="none" />
                    <polygon points={cubeViewFaces.back} />
                    <polygon points={cubeViewFaces.front} />
                    <line x1="9" y1="6" x2="7" y2="8" />
                    <line x1="17" y1="6" x2="15" y2="8" />
                    <line x1="17" y1="14" x2="15" y2="16" />
                    <line x1="9" y1="14" x2="7" y2="16" />
                </g>
            ) : (
                <g
                    transform={transform}
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.6"
                >
                    <polygon points={highlightedFace} fill="currentColor" fillOpacity="0.22" stroke="none" />
                    <polygon points={cubeViewFaces.top} />
                    <polygon points={cubeViewFaces.front} />
                    <polygon points={cubeViewFaces.right} />
                </g>
            )}
        </SvgIcon>
    );
}

QuickViewCubeIcon.propTypes = {
    className: PropTypes.string,
    view: PropTypes.oneOf([
        'front',
        'left',
        'right',
        'top',
        'bottom',
        'behind',
    ]).isRequired,
};

QuickViewCubeIcon.defaultProps = {
    className: undefined,
};

export default QuickViewCubeIcon;
